import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { updateDiagramProcessFlowDirection, getDiagramProcessFlowDirection, rebuildPVDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type SetProcessFlowDirectionProps = ApiMethodBase & {
    direction: number;
};

export const setProcessFlowDirection = ({
    direction,
    diagram,
}: SetProcessFlowDirectionProps) => {
    diagram.layout.direction = direction;
    updateDiagramProcessFlowDirection({ direction });
    if (apiProvider.getActiveAction() ==='process_miner') rebuildPVDiagram('updateDiagramProcessFlowDirection');
};


export const getProcessFlowDirection = (): SetProcessFlowDirectionProps => getDiagramProcessFlowDirection();
